import React from 'react'; 
import moment from 'moment';
import { Alert, Form, Radio, DatePicker } from 'antd';
import dayjs from 'dayjs';

const FormItemPublished = () => {
    return ( 
        <>   
            { /* Published radio buttons */ }
            <Form.Item name="isPublished">
                <Radio.Group>
                    <Radio.Button
                        value={ false }
                    >
                        Not Published
                    </Radio.Button>
                    <Radio.Button 
                        value={ true }
                    >
                        Published
                    </Radio.Button>
                </Radio.Group>
            </Form.Item>

            { /* Published date picker, only shows if isPublished is false */ }              
            <Form.Item
                noStyle
                shouldUpdate={ ( prevValues, currentValues ) => 
                    prevValues.isPublished !== currentValues.isPublished }
            >
                { 
                    ( { getFieldValue } ) => {
                        return !getFieldValue( 'isPublished' ) && 
                            <Form.Item  
                                name="_publishAt"
                                label={ `Publish At (${ Intl.DateTimeFormat().resolvedOptions().timeZone } )` }
                                rules={ [
                                    {
                                        message: 'The publish date and time must be in the future.',
                                        validateTrigger: [],
                                        validator: ( _, value ) => {
                                            if ( !value || dayjs( value ).isAfter( dayjs(), 'minute' ) ) {
                                                return Promise.resolve();
                                            } else {
                                                return Promise.reject();
                                            }
                                        }
                                    }
                                ] }    
                            >
                                <DatePicker 
                                    inputReadOnly
                                    showNow={ false }
                                    format="YYYY-MM-DD HH:mm"
                                    showTime={ {
                                        defaultValue: dayjs( '00:00', 'HH:mm' ),
                                        minuteStep: 5
                                    } }
                                    disabledDate={ current => {
                                        return current.isBefore( dayjs(), 'day' );
                                    } }
                                />
                            </Form.Item>;
                    }
                }
            </Form.Item>

            { /* Published info block */ }              
            <Form.Item
                noStyle
                shouldUpdate={ ( prevValues, currentValues ) => 
                    prevValues.isPublished !== currentValues.isPublished }
            >
                {
                    ( { getFieldValue } ) => {
                        return getFieldValue( 'isPublished' ) ?
                            <Alert
                                description={ <span><strong>Published</strong> indicates that this objective 
                                    will be visible to users but they will not be able to complete it unless 
                                    it has a <strong>Start Date</strong></span> }
                                type="info"
                            />
                            :
                            <Alert
                                description={ <span><strong>Not Published</strong> indicates that this objective
                                    will not be visible to any users but you can set a <strong>Publish At</strong> date
                                    and it will become published on that date.</span> }
                                type="info"
                            />;
                    }
                }
            </Form.Item>
        </>
    );
};

export default FormItemPublished;
